import type { ComponentType } from 'react';

/**
 * Feeling values as indexed by DM. These must match the DM `feelings` attribute exactly (case-sensitive).
 */
export enum WizardFeeling {
  Blissful = 'Blissful',
  Creative = 'Creative',
  Energetic = 'Energetic',
  Hungry = 'Hungry',
  NotHigh = 'Not high',
  PainFree = 'Pain free',
  Relaxed = 'Relaxed',
  Relieved = 'Relieved',
  Sleepy = 'Sleepy',
}

export enum WizardStepKey {
  Brand = 'brand',
  Category = 'category',
  Feelings = 'feelings',
  Lineage = 'lineage',
  Price = 'price',
}

export interface WizardStepProps {
  form: WizardFormData;
  updateForm: (form: WizardFormData) => void;
}

interface WizardStepConfig {
  enabledForStore?: (props: WizardProps) => boolean;
  filterComponent: ComponentType<WizardStepProps>;
  title: string;
}

export type WizardSteps = Record<WizardStepKey, WizardStepConfig>;

export type WizardFormData = Record<WizardStepKey, string[]>;

export interface WizardProps {
  customProductTypeLabels?: Record<string, string>;
  disabledCategories: string[];
  disabledFeelingTags: string[];
  // Flag-driven from the consuming app (FLAGS.c3ShowRelievedFeelingLabel). Renames
  // the tile only; the value sent to DM is unchanged, and expandFeelings makes
  // either value match both.
  showRelievedFeelingLabel?: boolean;
  storeState?: string | null;
}
